export default "__VITE_ASSET__cd0c4262__"